import * as types from '../actions/actionTypes';

export default function accountReducer(state = [], action) {
  let newState;
  switch (action.type) {

    case types.LOAD_ACCOUNTS_SUCCESS:
      return action.accounts

    case types.CREATE_ACCOUNT_SUCCESS:
      newState = Object.assign({},state);
      newState.newAccount = action.newAccount;

      return [...state,
        Object.assign({},action.newAccount)
      ];

    case types.SAVE_ACCOUNT_SUCCESS:
      return [...state.filter(updatedAccount => updatedAccount.id !== action.updatedAccount.id),
        Object.assign({},action.updatedAccount)
      ];

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/accountReducer.js